import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Section } from '../../../editor-container/editor-model';
import { DynamicSectionRendererDirective } from '../dynamic-section-renderer.directive';
import { SectionRendererComponent } from '@urbannex/storethemes';


@Component({
  selector: 'kw-preview-section',
  templateUrl: './preview-section.component.html',
  styleUrls: ['./preview-section.component.scss']
})
export class PreviewSectionComponent implements OnInit,AfterViewInit,OnChanges {
  @Input() section:Section;


  @ViewChild('sectionHost', {read: DynamicSectionRendererDirective}) private sectionHost!: DynamicSectionRendererDirective; 

  constructor(private cdr: ChangeDetectorRef) { }
  

  ngOnInit(): void {

  }

  ngOnChanges(changes:SimpleChanges):void{
    if(changes["section"]){
      console.log({TrackSection:this.section})
      this.cdr.detectChanges();
    }
  }
  ngAfterViewInit(): void {
    this.loadComponent();
  }


  /**
   * Loads the renderer component dynamically
   * The component is either a custom template
   * Or it could be one of the preset components found in SectionRendererComponent
   */
  loadComponent(){
    let componentRef = null;
    const viewContainerRef = this.sectionHost.viewContainerRef;
    if(this.sectionHost.sectionTemplate != null && this.sectionHost.sectionTemplate != undefined){
      componentRef = viewContainerRef.createComponent(this.sectionHost.sectionTemplate);
    }else{
      componentRef = viewContainerRef.createComponent(SectionRendererComponent);
      /* const sectionData = this.sectionHost.sectionData.subscribe(data => {
        console.log(data);
        return data;
      }) */
      console.log(this.sectionHost.sectionData);
      //console.log(this.sectionHost.title);
      componentRef.setInput("sectionData",this.sectionHost.sectionData);
      componentRef.setInput("title",this.sectionHost.title);
      componentRef.changeDetectorRef.detectChanges();
      //componentRef.instance.heading = "This is a kak heading";
     
    }
  }

}
